import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sorting-algorithms" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Sorting Algorithm Visualiser"),
  /*#__PURE__*/_createElementVNode("p", null, "A classic coding exercise demonstrating how sorting algorithms work.")
], -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "custom-chart"
}
const _hoisted_6 = { class: "options" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "d-flex justify-content-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = { class: "d-flex justify-content-between" }
const _hoisted_11 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_12 = { class: "d-flex justify-content-end mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_highcharts = _resolveComponent("highcharts")!
  const _component_it_switch = _resolveComponent("it-switch")!
  const _component_it_select = _resolveComponent("it-select")!
  const _component_it_number_input = _resolveComponent("it-number-input")!
  const _component_it_button = _resolveComponent("it-button")!
  const _component_it_button_group = _resolveComponent("it-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.temp > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Temp: " + _toDisplayString(_ctx.temp), 1))
        : _createCommentVNode("", true),
      (_ctx.chartType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet, (number, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "bar",
                key: index,
                style: _normalizeStyle({height: ((number * 10) + 10) + 'px', backgroundColor: _ctx.getColour(index)})
              }, _toDisplayString(number), 5))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_highcharts, {
            key: 2,
            type: "chart",
            ref: "chart",
            options: _ctx.chartOptions
          }, null, 8, ["options"]))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_it_switch, {
          modelValue: _ctx.chartType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chartType) = $event)),
          "hide-controls": true,
          label: _ctx.labelName
        }, null, 8, ["modelValue", "label"]),
        _createVNode(_component_it_select, {
          modelValue: _ctx.speed,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.speed) = $event)),
          placement: "top",
          options: _ctx.speedOptions
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_it_number_input, {
          modelValue: _ctx.dataSetSize,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataSetSize) = $event)),
          "label-left": "Data set size",
          "resize-on-write": "",
          min: 1,
          max: 40,
          disabled: _ctx.operating
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_it_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_it_button, {
              type: "black",
              outlined: "",
              onClick: _ctx.initialiseData,
              disabled: _ctx.operating
            }, {
              default: _withCtx(() => [
                _createTextVNode("Initialise")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_it_button, {
              type: "black",
              outlined: "",
              onClick: _ctx.randomiseData,
              disabled: _ctx.operating
            }, {
              default: _withCtx(() => [
                _createTextVNode("Randomise")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_it_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_it_button, {
              class: "btn-sort",
              type: "black",
              outlined: "",
              onClick: _ctx.bubbleSort,
              disabled: _ctx.operating
            }, {
              default: _withCtx(() => [
                _createTextVNode("Bubble Sort")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_it_button, {
              class: "btn-sort-optimised",
              type: "black",
              outlined: "",
              onClick: _ctx.bubbleSortOptimised,
              disabled: _ctx.operating
            }, {
              default: _withCtx(() => [
                _createTextVNode("Bubble Sort (Optimised)")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_it_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_it_button, {
              class: "btn-sort",
              type: "black",
              outlined: "",
              onClick: _ctx.selectionSort,
              disabled: _ctx.operating
            }, {
              default: _withCtx(() => [
                _createTextVNode("Selection Sort")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_it_button, {
              class: "btn-sort-optimised",
              type: "black",
              outlined: "",
              onClick: _ctx.selectionSortOptimised,
              disabled: _ctx.operating
            }, {
              default: _withCtx(() => [
                _createTextVNode("Selection Sort (Optimised)")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_it_button, {
          class: "btn-sort-full",
          type: "black",
          outlined: "",
          onClick: _ctx.insertionSort,
          disabled: _ctx.operating
        }, {
          default: _withCtx(() => [
            _createTextVNode("Insertion Sort")
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ])
  ]))
}